import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { fmtMoney, fmtNumber, fmtRPM } from "./defaults";

export function exportLoadPDF(load, metrics, t) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();

  // Header banner
  doc.setFillColor(10, 17, 40); // #0A1128
  doc.rect(0, 0, pageWidth, 80, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text("LoadWise", 40, 40);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Load Profitability Report", 40, 60);

  const dateStr = new Date().toLocaleString("en-US");
  doc.text(dateStr, pageWidth - 40 - doc.getTextWidth(dateStr), 60);

  // Route
  doc.setTextColor(15, 23, 42);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text(
    `${load.pick_city || "-"}  ->  ${load.delivery_city || "-"}`,
    40,
    115
  );

  // Load Info Table
  autoTable(doc, {
    startY: 135,
    head: [["Load Information", "Value"]],
    body: [
      ["Pick City", load.pick_city || "-"],
      ["Delivery City", load.delivery_city || "-"],
      ["Loaded Miles", fmtNumber(load.loaded_miles)],
      ["Empty Miles", fmtNumber(load.empty_miles)],
      ["Pickup Time", load.pickup_time || "-"],
      ["Delivery Time", load.delivery_time || "-"],
      ["Weight (lbs)", fmtNumber(load.weight)],
      ["Commodity", load.commodity || "-"],
      ["Rate", fmtMoney(load.rate)],
    ],
    theme: "striped",
    headStyles: { fillColor: [29, 78, 216], textColor: 255 },
    styles: { font: "helvetica", fontSize: 10 },
  });

  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 20,
    head: [["Cost Settings", "Value"]],
    body: [
      ["Cost Per Mile", fmtMoney(load.cost_per_mile)],
      ["Driver Pay Per Mile", fmtMoney(load.driver_pay_per_mile)],
      ["Dispatcher Fee", `${load.dispatcher_fee_pct}%`],
      ["Minimum Profit Goal", fmtMoney(load.min_profit_goal)],
    ],
    theme: "striped",
    headStyles: { fillColor: [29, 78, 216], textColor: 255 },
    styles: { font: "helvetica", fontSize: 10 },
  });

  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 20,
    head: [["Profitability Analysis", "Value"]],
    body: [
      ["Total Miles", fmtNumber(metrics.total_miles)],
      ["Real RPM", fmtRPM(metrics.real_rpm)],
      ["Total Rate", fmtMoney(load.rate)],
      ["Trip Cost", fmtMoney(metrics.trip_cost)],
      ["Driver Pay", fmtMoney(metrics.driver_pay)],
      ["Dispatcher Fee", fmtMoney(metrics.dispatcher_fee)],
      ["Net Profit", fmtMoney(metrics.net_profit)],
      ["Profit Per Mile", fmtRPM(metrics.profit_per_mile)],
    ],
    theme: "striped",
    headStyles: { fillColor: [29, 78, 216], textColor: 255 },
    styles: { font: "helvetica", fontSize: 10 },
  });

  // Decision badge
  const y = doc.lastAutoTable.finalY + 30;
  const isP = metrics.is_profitable;
  doc.setFillColor(...(isP ? [22, 163, 74] : [220, 38, 38]));
  doc.roundedRect(40, y, pageWidth - 80, 50, 6, 6, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  const label = isP ? "PROFITABLE LOAD" : "NOT PROFITABLE";
  doc.text(label, pageWidth / 2, y + 32, { align: "center" });

  const filename = `load-${(load.pick_city || "pick").split(",")[0]}-${(load.delivery_city || "del").split(",")[0]}-${Date.now()}.pdf`;
  doc.save(filename);
}

export function exportComparisonPDF(loadA, loadB) {
  const doc = new jsPDF({ unit: "pt", format: "a4", orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFillColor(10, 17, 40);
  doc.rect(0, 0, pageWidth, 70, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text("Load Comparison Report", 40, 40);

  const rows = [
    ["Route", `${loadA.pick_city} -> ${loadA.delivery_city}`, `${loadB.pick_city} -> ${loadB.delivery_city}`],
    ["Rate", fmtMoney(loadA.rate), fmtMoney(loadB.rate)],
    ["Total Miles", fmtNumber(loadA.total_miles), fmtNumber(loadB.total_miles)],
    ["Real RPM", fmtRPM(loadA.real_rpm), fmtRPM(loadB.real_rpm)],
    ["Trip Cost", fmtMoney(loadA.trip_cost), fmtMoney(loadB.trip_cost)],
    ["Driver Pay", fmtMoney(loadA.driver_pay), fmtMoney(loadB.driver_pay)],
    ["Dispatcher Fee", fmtMoney(loadA.dispatcher_fee), fmtMoney(loadB.dispatcher_fee)],
    ["Net Profit", fmtMoney(loadA.net_profit), fmtMoney(loadB.net_profit)],
    ["Profit / Mile", fmtRPM(loadA.profit_per_mile), fmtRPM(loadB.profit_per_mile)],
    ["Decision", loadA.is_profitable ? "PROFITABLE" : "NOT PROFITABLE", loadB.is_profitable ? "PROFITABLE" : "NOT PROFITABLE"],
  ];

  autoTable(doc, {
    startY: 100,
    head: [["Metric", "Load A", "Load B"]],
    body: rows,
    theme: "grid",
    headStyles: { fillColor: [29, 78, 216], textColor: 255 },
    styles: { font: "helvetica", fontSize: 11, cellPadding: 8 },
  });

  doc.save(`comparison-${Date.now()}.pdf`);
}
